export const respondentNotificationSettings = {
  autoresponderActive: false,
  autoresponderReceiver: '',
  autoresponderSenderName: 'Elfsight',
  autoresponderReplyTo: '',
  autoresponderSubject: 'We have received your message',
  autoresponderTemplate:
    '<div>Hello,</div><br><div>Thank you for reaching out. We received your email and will get back to you with a response as soon as possible</div>',
  autoresponderEI: ''
};

export type RespondentNotificationSettings =
  typeof respondentNotificationSettings;
